import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { t } from 'ttag';
import * as Sentry from '@sentry/react';

import loadTranslations from 'js/localeSetup';
import client from '../utils/client';
import './popularCategoriesIndex.less';

class PopularCategoriesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: window.config.global_nav,
      list: [],
      width: window.innerWidth,
      initState: false
    };
  }

  componentDidMount() {
    if (!this.state.initState) {
      const siteID = window.siteId;
      const endoint = `/navigation/top_categories/${siteID}/`;
      client
        .get(endoint)
        .then(res => {
          this.setState({ list: res.data.top_categories });
        })
        .catch(error => {
          Sentry.withScope(scope => {
            scope.setTag('location', 'Top Categories Index');
          });
          Sentry.captureException(error);
        });
    }
    window.addEventListener('resize', this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  }

  updateWidth = () => {
    setTimeout(() => {
      this.setState({ width: window.innerWidth });
    }, 300);
  };

  noOfColumns = width => {
    if (width < 1024) {
      if (width < 768) return 2;
      return 3;
    }
    return 6;
  };

  returnList(items, width) {
    const noOfItems = items.length;
    const widthOfItem = 100 / this.noOfColumns(width);
    const widthOfItemPercent = `${widthOfItem}%`;
    const heightOfItem = 25;
    const heightFormula =
      Math.ceil(noOfItems / this.noOfColumns(width)) * heightOfItem;
    const styleList = {
      height: heightFormula
    };

    const styleItem = {
      width: widthOfItemPercent
    };

    return (
      <ul style={styleList} className="pc-list">
        {items.map(item => {
          return (
            <a
              key={item.slug}
              className="pc-item"
              href={`/${item.slug}`}
              style={styleItem}
            >
              <span>{item.title}</span>
            </a>
          );
        })}
      </ul>
    );
  }

  render() {
    return (
      <div className="divider container">
        <div className="h-divider" />
        {this.state.flag && (
          <>
            <p className="title">{t`Popular Categories`}</p>
            {this.state.initState
              ? this.returnList(
                  window.__INITIAL_NAVIGATION_STATE__.top_categories,
                  this.state.width
                )
              : this.returnList(this.state.list, this.state.width)}
          </>
        )}
      </div>
    );
  }
}

(async () => {
  const rootElement = document.getElementById('popularCategoriesIndex');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<PopularCategoriesIndex />, rootElement);
  }
})();
